import { render } from "./2Fa.vue?vue&type=template&id=eb357880&scoped=true&ts=true"
import script from "./2Fa.vue?vue&type=script&lang=ts"
export * from "./2Fa.vue?vue&type=script&lang=ts"

import "./2Fa.vue?vue&type=style&index=0&id=eb357880&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb357880"]])

export default __exports__